import React, { Component } from "react";
import { Col, Row, FormGroup, Label, Modal } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import {
  createAmenityType,
  updateAmenityType,
  removeAmenityType,
  getAmenityTypeList,
  editAmenityType,
} from "../../Endpoint/Admin/index";
import { toast } from "react-toastify";
import { ConsolePage } from "../../components/Console/ConsoleLayout";
import {
  C, Panel, Table, Btn, IconBtn, SearchPill, PanelLink, ConfirmDialog,
} from "../../components/Console/ConsoleUI";
import { canWrite, hasModuleAccess } from "../../services/PermissionService";

/**
 * Amenity types — the small vocabulary every amenity is filed under
 * ("Bathroom", "Kitchen", …), restyled onto the console shell.
 *
 * The record holds one field, `type`, and nothing else: the list endpoint
 * strips isActive and both timestamps. So this screen deliberately shows one
 * column and no KPI row — there is no second fact about a type to report, and
 * a tile counting the same list twice would be decoration.
 *
 * Re-skin only: createAmenityType / updateAmenityType / removeAmenityType are
 * called with exactly the payloads the previous screen sent.
 */

class AmenityType extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      isLoaded: false,
      modal: false,
      amenityType: "",
      amenityTypeId: null,
      handleResponse: null,
      // View-only state — never changes what is fetched.
      search: "",
      showDeleteModal: false,
      pendingDelete: null,
      actionLoading: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.toggle = this.toggle.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.getALlluser = this.getALlluser.bind(this);
  }

  toggle() {
    this.setState({
      modal: !this.state.modal,
      amenityType: "",
      amenityTypeId: "",
    });
  }

  handleCloseModal() {
    this.setState({
      modal: false,
    });
  }

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    });
  };

  handleSubmit() {
    // AvForm has already blocked the browser's own submit before calling this;
    // by now React 16 has released the pooled event, so there is nothing left
    // to preventDefault.
    const aminityData = {
      amenityType: this.state.amenityType,
      amenityTypeId: this.state.amenityTypeId,
    };

    if (this.state.amenityTypeId == "" || this.state.amenityTypeId == null) {
      createAmenityType(aminityData)
        .then((response) => {
          if (response.status !== 200) {
            toast.error(response.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
            this.setState({
              handleResponse: {
                isSuccess: response.status === 200,
                message: "success",
                amenityType: "",
                amenityTypeId: "",
              },
            });
            this.getALlluser();
            this.handleCloseModal();
            toast.success("Amenity type added successfully");
          }
        })
        .catch((error) => {
          toast.error("error");
        });
    } else {
      updateAmenityType(aminityData)
        .then((updateResults) => {
          if (updateResults.status !== 200) {
            toast.error(updateResults.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
            this.setState({
              handleResponse: {
                isSuccess: updateResults.status === 200,
                message: "success",
                amenityTypeId: "",
              },
            });
            this.getALlluser();
            this.handleCloseModal();
            toast.success("Amenity updated successfully");
          }
        })
        .catch((error) => {
          toast.error("error");
        });
    }
  }

  removeAmenity(id) {
    this.setState({ actionLoading: true });
    removeAmenityType(id)
      .then((results) => {
        this.getALlluser();
      })
      .catch((error) => {
        toast.error("error");
      })
      .finally(() => {
        this.setState({
          actionLoading: false,
          showDeleteModal: false,
          pendingDelete: null,
        });
      });
  }

  getALlluser() {
    getAmenityTypeList().then((result) => {
      this.setState({
        isLoaded: true,
        items: (result && result.data) || [],
      });
    });
  }

  componentDidMount() {
    this.getALlluser();
  }

  editAmenityTypes(id) {
    editAmenityType(id)
      .then((results) => {
        this.setState({
          amenityType: results.data.type,
          amenityTypeId: results.data._id,
        });
      })
      .catch((error) => {
        toast.error("error");
      });
    this.setState({ modal: true });
  }

  // --- presentation ---------------------------------------------------------

  askDelete = (t) => this.setState({ showDeleteModal: true, pendingDelete: t });

  toggleDeleteModal = () =>
    this.setState({
      showDeleteModal: !this.state.showDeleteModal,
      pendingDelete: null,
    });

  /** Client-side filter over the loaded list. No request is made. */
  visibleTypes() {
    const q = this.state.search.trim().toLowerCase();
    if (!q) return this.state.items || [];
    return (this.state.items || []).filter((t) =>
      String(t.type || "").toLowerCase().includes(q)
    );
  }

  columns() {
    const write = canWrite();
    return [
      {
        key: "type",
        label: "Amenity type",
        render: (t) => (
          <div style={{ display: "flex", alignItems: "center", gap: 11 }}>
            <span
              className="ms"
              style={{
                fontSize: 19,
                color: C.brown,
                background: C.iconTint,
                padding: 7,
                borderRadius: 10,
              }}
            >
              label
            </span>
            <span style={{ fontSize: 15, color: C.ink }}>
              {t.type || "Untitled type"}
            </span>
          </div>
        ),
      },
      // Write controls stay behind canWrite(): a view-only account still sees
      // every type, just no way to change one.
      ...(write
        ? [
            {
              key: "actions",
              label: "",
              width: 96,
              align: "right",
              render: (t) => (
                <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
                  <IconBtn
                    icon="edit"
                    title={`Edit ${t.type || "type"}`}
                    onClick={() => this.editAmenityTypes(t._id.toString())}
                  />
                  <IconBtn
                    icon="delete"
                    tone="bad"
                    title={`Remove ${t.type || "type"}`}
                    onClick={() => this.askDelete(t)}
                  />
                </div>
              ),
            },
          ]
        : []),
    ];
  }

  renderModal() {
    const { amenityTypeId } = this.state;
    const editing = !!amenityTypeId;

    return (
      <Modal isOpen={this.state.modal} toggle={this.toggle} className="con-modal" centered>
        <div style={{ padding: 30 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
            <span
              className="ms"
              style={{
                fontSize: 26,
                color: C.brown,
                background: C.iconTint,
                padding: 13,
                borderRadius: 16,
              }}
            >
              label
            </span>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 22, fontWeight: 500, color: C.ink }}>
                {editing ? "Edit amenity type" : "Add amenity type"}
              </div>
              <div style={{ marginTop: 4, fontSize: 14, color: C.taupe }}>
                {editing
                  ? "Amenities already filed under this type follow the new name"
                  : "A group amenities are filed under, such as Bathroom or Kitchen"}
              </div>
            </div>
            <button
              type="button"
              onClick={this.toggle}
              aria-label="Close"
              style={{
                border: 0,
                background: "transparent",
                color: C.taupeLight,
                cursor: "pointer",
                padding: 4,
                lineHeight: 1,
              }}
            >
              <span className="ms" style={{ fontSize: 22 }}>close</span>
            </button>
          </div>

          <AvForm onValidSubmit={this.handleSubmit}>
            <div style={{ marginTop: 24 }}>
              <Row form>
                <Col md={12}>
                  <FormGroup>
                    <Label for="amenityType">Type name</Label>
                    <AvField
                      type="text"
                      value={this.state.amenityType}
                      onChange={this.handleChange}
                      id="amenityType"
                      name="amenityType"
                      placeholder="e.g. Bathroom"
                      required
                                  errorMessage="Type name is required"
                                />
                  </FormGroup>
                </Col>
              </Row>
            </div>

            <div style={{ marginTop: 8, display: "flex", gap: 12 }}>
              <button
                type="button"
                onClick={this.toggle}
                style={{
                  flex: 1,
                  height: 52,
                  border: "1px solid #e6d8c4",
                  borderRadius: 26,
                  background: "#fff",
                  color: C.slate,
                  fontFamily: "inherit",
                  fontSize: 15,
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>
              {/* AvForm's validation runs on a real submit, so this stays a
                  submit button rather than an onClick handler. */}
              <button
                type="submit"
                style={{
                  flex: 1,
                  height: 52,
                  border: 0,
                  borderRadius: 26,
                  background: C.brown,
                  color: "#fff",
                  fontFamily: "inherit",
                  fontSize: 15,
                  cursor: "pointer",
                }}
              >
                {editing ? "Save changes" : "Add type"}
              </button>
            </div>
          </AvForm>
        </div>
      </Modal>
    );
  }

  render() {
    const { items, isLoaded, search, pendingDelete } = this.state;
    const write = canWrite();
    const visible = this.visibleTypes();

    return (
      <ConsolePage
        title="Amenity types"
        subtitle={
          isLoaded
            ? `${(items || []).length} type${(items || []).length === 1 ? "" : "s"}${
                search.trim() ? ` · ${visible.length} matching` : ""
              }`
            : "Loading amenity types…"
        }
        actions={
          <React.Fragment>
            <SearchPill
              value={search}
              onChange={(v) => this.setState({ search: v })}
              placeholder="Search types"
              width={220}
            />
            {write && (
              <Btn icon="add" onClick={this.toggle}>
                Add type
              </Btn>
            )}
          </React.Fragment>
        }
      >

        <div style={{ display: "grid", gridTemplateColumns: "1.5fr 1fr", gap: 20, alignItems: "start" }}>
          <Panel style={{ padding: 0 }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 12,
                padding: "16px 22px",
                borderBottom: `1px solid ${C.panel}`,
              }}
            >
              <div>
                <div style={{ fontSize: 17, fontWeight: 500, color: C.ink }}>All types</div>
                <div style={{ marginTop: 3, fontSize: 13, color: C.taupeLight }}>
                  Every amenity is filed under one of these
                </div>
              </div>
              <div style={{ fontSize: 14, color: C.taupeLight }}>
                {visible.length} of {(items || []).length} shown
              </div>
            </div>

            <div style={{ padding: "6px 8px" }}>
              {!isLoaded ? (
                <div style={{ padding: "48px 0", textAlign: "center", color: C.taupeLight }}>
                  Loading amenity types…
                </div>
              ) : (
                <Table
                  columns={this.columns()}
                  rows={visible}
                  empty={
                    (items || []).length === 0
                      ? "No amenity types yet — add the first one to start grouping amenities"
                      : "No type matches that search."
                  }
                />
              )}
            </div>
          </Panel>

          <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
            <Panel
              title="How types are used"
              subtitle="They group the amenities guests see on a room"
              style={{ display: "flex", flexDirection: "column", minHeight: 240 }}
            >
              <div style={{ marginTop: 14, fontSize: 14, color: C.slate, lineHeight: 1.6 }}>
                A type is a heading, not a feature. "Bathroom" is a type; the hairdryer
                and the bathrobe filed under it are amenities, and those carry the icon
                a guest sees.
              </div>
              <div style={{ marginTop: 14, fontSize: 13, color: C.taupeLight, lineHeight: 1.6 }}>
                The type record stores its name only — the list endpoint returns no
                created date and no usage count, so none is shown here.
              </div>
              {hasModuleAccess("AMENITY") && (
                <PanelLink onClick={() => this.props.history.push("/Amenities")}>
                  Amenities
                </PanelLink>
              )}
            </Panel>
          </div>
        </div>

        {this.renderModal()}

        <ConfirmDialog
          isOpen={this.state.showDeleteModal}
          toggle={this.toggleDeleteModal}
          onConfirm={() =>
            pendingDelete && this.removeAmenity(pendingDelete._id.toString())
          }
          icon="delete"
          title={`Remove ${pendingDelete ? pendingDelete.type : "this type"}?`}
          body="Amenities filed under it keep their record but lose this grouping."
          tip="Deleting cannot be undone — you would have to add the type again and re-file its amenities."
          confirmText="Remove"
          loading={this.state.actionLoading}
        />
      </ConsolePage>
    );
  }
}

export default AmenityType;
